"use client";

import Link from "next/link";
import { COMPANY_LOCATION } from "../../utils/constants";
import { ContactUsForm, FooterLinks, OurServices, SiteLink } from "../common/FooterLinks";
import { usePathname } from "next/navigation";

const Footer = () => {
  const pathname = usePathname();
  const hiddenPath = ["/login"];

  if (!hiddenPath.includes(pathname) && !pathname.startsWith("/admin")) {
    return (
      <footer>
        <div className="top ">
          <div className="container">
            <div className="row  flex top-left">
              <div className="flex  right">
                {/* first */}
                <div className="flex top-left col-2-5 first ">
                  <div className="mobile-t-a-c">
                    <h5 className="font-barlow f-w-500 p-24" style={{ paddingLeft: "12px", color: "#0B75B7" }}>
                      Corporate Offices
                    </h5>
                    <br></br>
                    <FooterLinks />
                  </div>
                </div>

                {/* second */}
                <div className="flex top-left col-1-4 second">
                  <div className="mobile-t-a-c">
                    <h5 className="font-barlow f-w-500 p-24" style={{ color: "#0B75B7" }}>
                      Site Links
                    </h5>
                    <br />
                    <SiteLink />
                  </div>
                </div>

                {/* Third */}
                <div className="flex top-left col-1-4 third">
                  <div className="mobile-t-a-c">
                    <h5 className="font-barlow f-w-500 p-24" style={{ color: "#0B75B7" }}>
                      Specialties
                    </h5>
                    <br />
                    <OurServices />
                  </div>
                </div>

                 {/* forth */}
              <div className="flex top-left col-1-4 fourth">
              <div className="mobile-t-a-c">
                <h5 className="font-barlow f-w-500 p-24" style={{ color: "#0B75B7" }}>
                  Subscribe To Our Newsletter
                </h5>
                <br />
                <ContactUsForm />
                </div>
              </div>

              
              </div>
             

            </div>
          </div>
        </div>

        {/* bottom */}
        <section className="bottom">
          <div className="container  ">
            {/* <div className=" col-1-1 row"></div> */}
            <div className="  has-border-top" style={{ padding: "20px 0 ", borderColor: "#4B445A" }}>
              <div className="flex   color-light-grey medium  bottom-box">
                <div>
                  {/* <p className="font-mont f-w-300 medium p-18">© {new Date().getFullYear()} Universal Surgical Assistants All Rights Reserved</p> */}
                  <p className="font-mont f-w-300 medium p-18">© 2025 - 2026 Universal Surgical Assistants All Rights Reserved</p>
                </div>
                <div className="mar-l-a privacy  ">
                  <div className=" flex center-center  ">
                    <Link href="/current-job-openings">
                      <span
                        className="font-mont f-w-500 medium transition hover-color-purple hover-text-underline"
                        style={{ marginRight: "5px", color: "#0B75B7" }}
                      >
                        Current Job Openings
                      </span>
                    </Link>
                    <Link href="/news" className="bor-l">
                      <span style={{ color: "#0B75B7" }} className="font-mont f-w-500 transition hover-color-purple hover-text-underline medium">
                        News and Updates
                      </span>
                    </Link>
                    <Link href="/privacy-policy" className="bor-l">
                      <span style={{ color: "#0B75B7" }} className="font-mont f-w-500 transition hover-color-purple hover-text-underline">
                        Privacy Policy
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </footer>
    );
  }
};

export default Footer;
